import { useEffect, useState } from 'react';

import { merchantisePantoneColor } from '../../../../utils/image';
import { mobileAndTabletDetection } from "../../../../utils/browser";
import { Modal, ModalBody } from '../../elements/Modal';
import Icon from '../../elements/icon';
import PreviewPopup from '../../sections/preview-popup'
import i18n from '../../../../utils/translations/i18n';
import { Page } from '../../../../enums/page';

const getImprintColorForCustomizedText = function (customizationType, imprintColorObj) {
    let colorObj: any = {};
    if (customizationType && imprintColorObj) {
        if (imprintColorObj.style && imprintColorObj.style !== '') {
            colorObj.rgb = imprintColorObj.style;
        }
        else if (customizationType === 'DIM') {
            if (imprintColorObj.type === 'pantone' || !imprintColorObj.type)
                colorObj = merchantisePantoneColor(imprintColorObj.color);
            else if (imprintColorObj.type === 'spot')
                colorObj = { rgb: '#C0C0C0' };
        } else if (customizationType === 'DIY') {
            colorObj = merchantisePantoneColor(imprintColorObj.color);
        }
        colorObj.bgcolor = '';
        if (colorObj.rgb.toLowerCase() === 'rgb(255,255,255)' || colorObj.rgb.toLowerCase() === '#ffffff') {
            colorObj.bgcolor = '#ccc';
        }
    }
    return colorObj || { 'rgb': '', bgcolor: '' };
};

const imprintImage_DIY = (customizationInfo) => {
    let bgColor = ''
    if (customizationInfo?.imageInfo?.[0]?.imprintColor) {
        const color = getImprintColorForCustomizedText('DIY', customizationInfo?.imageInfo?.[0].imprintColor)
        if (color.bgcolor)
            bgColor = color.bgcolor
    }
    
    if (bgColor === '') {
        const { lineInputArr } = customizationInfo?.textInfo
        for (const line of lineInputArr) {
            const color = getImprintColorForCustomizedText('DIY', line.imprintColor)
            if (color.bgcolor) {
                bgColor = color.bgcolor
                break;
            }
        }
    }
    return { imageUrl: customizationInfo?.renderingInstructionsUrl ?? '', bgColor: bgColor }
}

const imageInfo_DIY = ({customizationInfo, isMobileDevice, showModal, setShowModal, hideModal, pageName},styleObj) => {
    const { imageUrl, bgColor } = imprintImage_DIY(customizationInfo)
    return (
        <>
            <div className={`image-info ${pageName}`} style={{ "backgroundColor": bgColor, "display": "inline-block", "maxWidth": "100%" }}>
                <img alt="" src={imageUrl} data-testid='test-DIY-item-image' onClick={() => setShowModal(true) }/>
            </div>
            <PreviewPopup imprintImageUrl={imageUrl} bgColor={bgColor} showModal={showModal} style={styleObj} hideModal={hideModal}/>
        </>
    )
}

const preview_DIY = (customizationInfo, isOpen, toggleModal) => {
    return (
        <>
            <div>
                <a href="#!" onClick={toggleModal} className="link--underline centi open-modal preview-design">
                    {i18n.t('order_details.designPreviewLink')}
                </a>
                <Modal isOpen={isOpen} onClose={toggleModal}>
                    <>
                        <button onClick={toggleModal} className="modal-close">
                            <span title="Close(Esc)" className="icon-cancel" />
                        </button>
                        <ModalBody>
                            <img alt='previewImage' src={customizationInfo?.previewImageUrl} />
                        </ModalBody>
                    </>
                </Modal>
            </div>
        </>
    )
}


const imprintText_DIM = (textInfo) => {
    const color = getImprintColorForCustomizedText('DIM', textInfo.lineInputArr[0].imprintColor)
    return textInfo.lineInputArr.map((line) => {
        const fontFamily = (line['font-family']).trim().toLowerCase().replace(" ", "") ?? '';

        let cssClass = ''
        if (line['font-bold']) cssClass += ' bold '
        if (line['italic']) cssClass += ' italic '
        if (line['underline']) cssClass += ' underline '

        return {
            'cssClass': cssClass,
            'color': color.rgb,
            'bgColor': color.bgcolor,
            'font': fontFamily,
            'text': line.text
        }
    })
}

const textInfo_DIM = (customizationInfo) => {
    if (customizationInfo?.textInfo?.lineInputArr?.length > 0) {
        const htmlArr = imprintText_DIM(customizationInfo?.textInfo)
        return (
            <div className="text-info" style={{ 'backgroundColor': htmlArr[0].bgColor }} >
                {htmlArr.map((htmlObj) => {
                    const myStyle = {
                        'color': htmlObj.color,
                        'fontFamily': htmlObj.font
                    }
                    const cssClass = `text-line ${htmlObj.cssClass}`;

                    return (
                        <div className={cssClass} style={myStyle} key={htmlObj.color} >
                            {htmlObj.text}
                        </div>);
                })
                }
            </div>
        )
    }
}

const imprintImage_DIM = (customizationInfo) => {
    const color = getImprintColorForCustomizedText('DIM', customizationInfo?.imageInfo?.[0].imprintColor)

    if (customizationInfo?.imageInfo?.[0].modifiedImageUrl !== '')
        return { imageUrl: customizationInfo?.imageInfo?.[0].modifiedImageUrl, bgColor: color.bgcolor }
    else if (customizationInfo?.imageInfo?.[0].imageUrl !== '')
        return { imageUrl: customizationInfo?.imageInfo?.[0].imageUrl, bgColor: color.bgcolor }

    return { imageUrl: customizationInfo?.previewImageUrl, bgColor: '' }
}

const imageInfo_DIM = ({customizationInfo, isMobileDevice, showModal, setShowModal, hideModal, pageName},styleObj) => {
    if (customizationInfo?.imageInfo?.[0]) {
        const { imageUrl, bgColor } = imprintImage_DIM(customizationInfo)
        return (
            <>
                <div className={`image-info ${pageName}`} style={{ 'backgroundColor': bgColor }}>
                    <img alt="" src={imageUrl} data-testid='test-DIM-item-info-image' onClick={() => setShowModal(true) }/>
                </div>
                <PreviewPopup imprintImageUrl={imageUrl} bgColor={bgColor} showModal={showModal} style={styleObj} hideModal={hideModal}/>
            </>
        )
    }

    return (
        <>
            {customizationInfo?.previewImageUrl && 
                <div className={`image-info ${pageName}`} >
                    <img alt="" src={customizationInfo?.previewImageUrl} onClick={() => isMobileDevice && setShowModal(true) }/>
                </div>
            }
            <PreviewPopup imprintImageUrl={customizationInfo?.previewImageUrl} showModal={showModal} style={styleObj} hideModal={hideModal}/>
        </>
    )
}

const generateTemplatePreview = function (templateCimdoc) {
    let previewUrl = '';
    if (templateCimdoc) {
        let instructionUrl = '';
        if (templateCimdoc.includes('/v3/')) {
            instructionUrl = templateCimdoc.split('/documents/')[0];
            instructionUrl = instructionUrl + '/instructions:preview?documentUri=' + encodeURIComponent(templateCimdoc.replace('docref', '')) + '&category=docref';
        }
        else {
            instructionUrl = templateCimdoc.replace('docref', 'instructions');
        }
        previewUrl = 'https://cdn.rendering.documents.cimpress.io/v1/uds/preview?width=600&instructions_uri=' + encodeURIComponent(instructionUrl + '&type=preview') + '&format=png';
    }
    return previewUrl;
};

const templateInfo_DIM = (customizationInfo, pageName) => {
    if (customizationInfo?.templateCimDoc && customizationInfo?.templateCimDoc !== '') {
        const imageUrl = generateTemplatePreview(customizationInfo?.templateCimDoc)
        return (
            <div className={`image-info ${pageName}`}>
                <img alt="" src={imageUrl} />
            </div>
        )
    }
}

const imageInfo_USG = ({customizationInfo, isMobileDevice, showModal, setShowModal, hideModal, pageName},styleObj) => {
    return (
        <>
            <div className={`image-info ${pageName}`}>
                <img alt="" src={customizationInfo?.previewImageUrl} data-testid='test-usg-item-image' onClick={() =>  setShowModal(true) }/>
            </div>
            <PreviewPopup imprintImageUrl={customizationInfo?.previewImageUrl} showModal={showModal} style={styleObj} hideModal={hideModal}/>
        </>
    )
}

type ModalHandler = {
    setShowModal: (show: boolean) => void;
}
  
type ImprintProps = {
    customizationInfo: any;
    customizationType: any;
    showPreview: any;
    pageName: any;
    modalRef?: React.RefObject<ModalHandler> | null;
}
  
const Imprint: React.FC<ImprintProps> = ({customizationInfo, customizationType, showPreview, pageName, modalRef}) => {
    const isMobileDevice = mobileAndTabletDetection();
    const [isPreviewDesignOpen, setPreviewDesignState] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [styleObj, setPopupStyle] = useState({});

    useEffect(() => {
        if (modalRef && 'current' in modalRef) {
          (modalRef as any).current = {
            setShowModal
          };
        }
    }, [modalRef]);

    const hideModal = () => {
        setShowModal(false)
    };
    const togglePreviewDesignModal = () => setPreviewDesignState(!isPreviewDesignOpen);
    const customizationData = { customizationInfo, isMobileDevice, showModal, setShowModal, hideModal , pageName }
    
    useEffect(() => {
        if (!isMobileDevice && pageName === Page.CHECKOUTSHIPPING) {
          const previewPopupStartingPosition = document.querySelector('.summary-order-details');
          
          if (previewPopupStartingPosition) {
            const previewPopupPosition = previewPopupStartingPosition.getBoundingClientRect();
            const distanceFromRightEdge = window.innerWidth - (previewPopupPosition?.left || 0);
      
            if (distanceFromRightEdge) {
              setPopupStyle({
                left: 'auto',
                right: `${distanceFromRightEdge + 15}px`,
                transform: 'translateY(-50%)'
              });
            }
          }
        }
      }, [pageName, isMobileDevice]);

    if (customizationInfo?.isUsgProduct) {
        return (
            <>
                {imageInfo_USG(customizationData,styleObj)}
            </>
        )
    }
    else if (customizationType === "DIY") {
        return (
        <>
            {showPreview && imageInfo_DIY(customizationData,styleObj)}
            {preview_DIY(customizationInfo, isPreviewDesignOpen, togglePreviewDesignModal)}
        </>
        )
    }
    else if (customizationType === "DIM") {
        return (
            <>
                {textInfo_DIM(customizationInfo)} 
                {showPreview && imageInfo_DIM(customizationData,styleObj)}
                {templateInfo_DIM(customizationInfo, pageName)} 
            </>
        )
    }
    else if(customizationType === "NULL") {
        return(
            <>
                <div className="no-imprint">
                    {i18n.t('customize.no_customization_skip')}
                </div>
            </>
        )
    }

    return (
        <>
        </>
    )

}

export default Imprint;
